"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionEditing = ShopPageSubscriptionEditing;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const date_fns_1 = require("date-fns");
const page_1 = require("../../shared/contexts/page");
const site_1 = require("../../shared/contexts/site");
const types_1 = require("../../shared/types");
const modals_1 = require("../../shared/components/modals");
const loading_spinner_1 = require("../../shared/utils/loading-spinner");
const provider_1 = require("../provider");
function ShopPageSubscriptionEditing({ cartData, isLRPCreation }) {
    var _a, _b, _c, _d, _e;
    const { context } = (0, site_1.useSiteState)();
    const { showGlobalModal, hideGlobalModal } = (0, page_1.useModalsMutator)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { subscriptionContext } = (0, provider_1.useSubscriptionOverviewState)();
    function saveLrp(e) {
        let clickedElement = e.target;
        if (!clickedElement.hasAttribute('disabled') && !clickedElement.classList.contains('disabled')) {
            (0, loading_spinner_1.showLoadingSpinner)(clickedElement);
            fetch("/" + context + "/lrptemplate/getLrpStatus", {
                method: "POST"
            })
                .then(response => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    window.location.href = context + "/showErrorNotFoundPage";
                }
            })
                .then(isCancelled => {
                if (isCancelled) {
                    window.location.href = context + "/shop-home";
                }
                else {
                    fetch("/" + context + "/lrptemplate/validateCutOfTime", {
                        method: "POST", headers: {
                            "Content-Type": "application/json"
                        }
                    })
                        .then((response) => {
                        if (response.ok) {
                            return response.json();
                        }
                        window.location.href = context + "/showErrorNotFoundPage";
                    })
                        .then(isCutOfTimeReached => {
                        if (isCutOfTimeReached != null && isCutOfTimeReached == 'false') {
                            let modalName = "ValidateCutOffModal";
                            showGlobalModal(modalName, react_1.default.createElement(modals_1.ConfirmationModal, { type: modals_1.ModalType.warning, text: t("text.lrp.cutoff.reached"), acceptText: t("text.button.label.yes"), accept: () => {
                                    lrpProcessOnDate(context, clickedElement);
                                }, rejectText: t("text.button.label.no"), reject: () => {
                                    (0, loading_spinner_1.hideLoadingSpinner)(clickedElement);
                                    hideGlobalModal(modalName);
                                }, close: () => {
                                    (0, loading_spinner_1.hideLoadingSpinner)(clickedElement);
                                    hideGlobalModal(modalName);
                                } }));
                        }
                        else {
                            lrpProcessOnDate(context, clickedElement);
                        }
                    });
                }
            });
        }
    }
    function lrpProcessOnDate(context, clickedElement) {
        fetch("/" + context + "/lrptemplate/process", {
            method: "POST",
        })
            .then(response => {
            if (response.ok) {
                return response.json();
            }
        })
            .then(data => {
            let lrpData = data.cartData;
            if (lrpData.code == null) {
                if (data.orderError) {
                    showGlobalModal("Error Modal for order", react_1.default.createElement(modals_1.ErrorModal, { text: data.orderError }));
                }
                else if (data.lrpErrorMessage) {
                    let lrpErrorModal = "LRPErrorModal";
                    showGlobalModal(lrpErrorModal, react_1.default.createElement(modals_1.ErrorModal, { text: data.lrpErrorMessage, close: () => {
                            if (data.processOnErrorCode) {
                                window.location.href = "/" + context + data.closeButtonUrl;
                            }
                            else {
                                hideGlobalModal(lrpErrorModal);
                            }
                        } }));
                }
                else {
                    window.location.href = "/" + context + "/my-cart";
                }
            }
            else {
                if (lrpData.lrpTemplateValidationInformation != null && lrpData.lrpTemplateValidationInformation.length > 0) {
                    lrpData.lrpTemplateValidationInformation.forEach(data => {
                        if (data == "lowPV") {
                            showGlobalModal(data, react_1.default.createElement(modals_1.WarningModal, { text: t("text.min.pv.not.reached") }));
                            (0, loading_spinner_1.hideLoadingSpinner)(clickedElement);
                        }
                        else if (data == "cutOfDateReached" && data != "lowPV") {
                            pvPromotionCheck(cartData, clickedElement);
                        }
                    });
                }
                else {
                    pvPromotionCheck(cartData, clickedElement);
                }
            }
        });
    }
    function pvPromotionCheck(lrpData, clickedElement) {
        var message, i;
        if (lrpData.potentialOrderPromotions && lrpData.potentialOrderPromotions.length > 0) {
            for (i = 0; i < lrpData.potentialOrderPromotions.length; i++) {
                var potentialOrderPromotion = lrpData.potentialOrderPromotions[i];
                if (potentialOrderPromotion.promotionData.promotionType == 'doTerra PV-based Promotion') {
                    message = potentialOrderPromotion.description;
                }
            }
            if (message) {
                let modalName = "confirmationModal";
                showGlobalModal(modalName, react_1.default.createElement(modals_1.ConfirmationModal, { type: modals_1.ModalType.direction, text: message, acceptText: t("text.button.label.yes"), accept: () => {
                        window.preventAbandonCartAlert = true;
                        window.location.href = "/" + context + '/my-cart';
                    }, rejectText: t("text.button.label.no"), rejectClassNames: "btn btn-primary", reject: () => {
                        window.preventAbandonCartAlert = true;
                        window.location.href = "/" + context + '/cart/set-lrp-pvPromoDecision?isProcessOn=true';
                    }, close: () => {
                        (0, loading_spinner_1.hideLoadingSpinner)(clickedElement);
                        hideGlobalModal(modalName);
                    } }));
            }
            else {
                window.preventAbandonCartAlert = true;
                window.location.href = "/" + context + "/checkout/lrp-order-confirmation";
            }
        }
        else {
            window.preventAbandonCartAlert = true;
            window.location.href = "/" + context + "/checkout/lrp-order-confirmation";
        }
    }
    function abandonCartMsg() {
        window.preventAbandonCartAlert = true;
        let modalName = "AbandonCartMsgModal";
        showGlobalModal(modalName, react_1.default.createElement(modals_1.ConfirmationModal, { type: modals_1.ModalType.warning, title: t("order.abandonOrder.modal"), text: t("text.change.removal.warning.msg"), acceptText: t("text.button.label.yes"), accept: () => {
                (0, loading_spinner_1.showLoadingSpinner)();
                window.location.href = "/" + context + '/cart/clear';
            }, rejectText: t("text.button.label.no"), reject: () => {
                window.preventAbandonCartAlert = false;
                hideGlobalModal(modalName);
            }, close: () => {
                window.preventAbandonCartAlert = false;
                hideGlobalModal(modalName);
            } }));
    }
    function redirectMyCart() {
        (0, loading_spinner_1.showLoadingSpinner)();
        let contextVal = context;
        if (contextVal && !contextVal.startsWith('/')) {
            contextVal = '/' + contextVal;
        }
        window.location.href = contextVal + types_1.AppRoutes.MyCart;
    }
    let formattedActivationDate = cartData.lrpNextActivationDate ? (0, date_fns_1.format)(cartData.lrpNextActivationDate, 'MMMM dd') : "";
    const headerText = ((_a = cartData === null || cartData === void 0 ? void 0 : cartData.lrpSubscription) === null || _a === void 0 ? void 0 : _a.subscriptionName)
        ? t('edit.loyalty.header')
        : isLRPCreation
            ? t('text.create.subscription.header')
            : t('edit.loyalty.header');
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "loyalties__orders-box-results text-center" }, (cartData === null || cartData === void 0 ? void 0 : cartData.lrpSubType) === types_1.LrpSubType.INSTANT ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-editing-header" }, t('text.header.instantrewards.orders')),
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-editing-text" }, t('edit.instantrewards.text')),
            cartData.totalUnitCount > 0 && react_1.default.createElement("button", { onClick: redirectMyCart, className: "btn btn-primary text-white" }, t('label.order.history.view')),
            react_1.default.createElement("button", { onClick: () => abandonCartMsg(), className: "btn btn-invert" }, t('order.abandonOrder.edit'))) : react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-editing-header" }, headerText),
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-editing-header" }, (_c = (_b = cartData === null || cartData === void 0 ? void 0 : cartData.lrpSubscription) === null || _b === void 0 ? void 0 : _b.subscriptionName) !== null && _c !== void 0 ? _c : subscriptionContext.message,
                " - ",
                formattedActivationDate),
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-editing-text" }, t('edit.loyalty.text')),
            react_1.default.createElement("button", { id: "btn-historyView", onClick: redirectMyCart, disabled: ((_d = cartData === null || cartData === void 0 ? void 0 : cartData.entries) === null || _d === void 0 ? void 0 : _d.length) < 1, className: "btn btn-primary text-white" }, t('label.order.history.view')),
            react_1.default.createElement("button", { className: "process-lrp btn btn-primary banner-link", disabled: ((_e = cartData.entries) === null || _e === void 0 ? void 0 : _e.length) < 1, onClick: saveLrp }, t('text.button.label.saveOrder')),
            react_1.default.createElement("button", { onClick: () => abandonCartMsg(), className: "btn btn-invert" }, t('order.abandonOrder.edit')))));
}
